import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MedicalGuide } from '../../models/api';
import { AppState } from '../../models/state';
import { EventsService } from '../../services/events.service';
import { StateService } from '../../services/state.service';
import { UiService } from 'src/app/shared/services/ui.service';
import { UtilsService } from '../../services/utils.service';
import { ApiService } from '../../services/api.service';
import { ContextService } from '../../services/ctx.service';

@Component({
  selector: 'app-download-pdf-card',
  templateUrl: './download-pdf-card.component.html',
  styleUrls: ['./download-pdf-card.component.scss']
})
export class DownloadPdfCardComponent implements OnDestroy {
  indexSelected: number;
  subs: Subscription;
  state: Partial<AppState>;

  @Input() index: number;
  @Input() data: MedicalGuide;

  constructor(
    public ui: UiService,
    public utils: UtilsService,
    public api: ApiService,
    public ctx: ContextService,
    private events: EventsService,
    private stateService: StateService,
  ) {
    this.subs = new Subscription();
    this.state = this.stateService.getStateValue();
    this.setEvents();
    this.indexSelected = 0;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  openDownloadMedicaGuideModal() {
    if (this.state?.provinces?.length > 0) {
      this.ui.openDownloadMedicaGuideModal(this.data);
      return;
    }

    this.api.getProvinces().subscribe(provinces => {
      this.state.provinces = provinces;
      this.stateService.updateState(this.state);
      this.ui.openDownloadMedicaGuideModal(this.data);
    });
  }

  private setEvents() {
    this.subs.add(
      this.events.selectedIndexEvent().subscribe(index => {
        this.indexSelected = index;
      })
    );

    this.subs.add(
      this.stateService.getState().subscribe(state => {
        this.state = state;
      }));
  }
}
